import { getWithAuth } from '../../../Basic/HttpService';

export const getAllVmrsCategorys = async () => {
    let res = await getWithAuth(`VMRSCategory`);
    return res;
};
